import { DatePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";

import { GqlPermissions } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import {
    ProtocolVisitCondition,
    VisitConditionMaxDate,
    VisitConditionMinDate,
} from "../../types/ProtocolVisitCondition";

type Props = {
    label: string;
    condition: VisitConditionMinDate | VisitConditionMaxDate;
    onChange: (condition?: ProtocolVisitCondition) => void;
};

export default function ConditionEditorDate({ label, condition, onChange }: Props) {
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);
    return (
        <DatePicker
            disabled={!isAdmin}
            sx={{ width: "100%" }}
            label={label}
            onChange={newDate => {
                if (newDate && !isNaN(newDate.getTime())) {
                    onChange({
                        ...condition,
                        date: format(newDate, "yyyy-MM-dd"),
                    });
                }
            }}
            value={condition.date ? new Date(condition.date) : null}
        />
    );
}
